<template>
  <div class="c-btn-wrap">
    <button
      class="c-btn"
      name="submit"
      type="button"
      @click.prevent="submitForm">
      {{ confirmButton }}
      <span class="c-btn__icon-arrow" />
    </button>
    <button
      class="c-btn c-btn--back c-btn--back-left"
      type="button"
      @click.prevent="viewForm()">
      <span> {{ backButton }} </span>
      <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'RevenueShareFormBottomArea',
  props: {
    confirmButton: {
      type: String,
      required: true,
    },
    backButton: {
      type: String,
      required: true,
    },
  },
  methods: {
    viewForm() {
      this.$emit('viewForm', true)
    },
    submitForm() {
      this.$emit('submitForm')
    },
  },
}
</script>

<style scoped>
</style>
